export const USER_EDIT_USERNAME_MODAL_QA_NAME = 'EditUsername'

export const USER_EDIT_USERNAME_FORM_MODAL_FIELD_NAME_FIRST_NAME = 'first_name'

export const USER_EDIT_USERNAME_FORM_MODAL_FIELD_NAME_LAST_NAME = 'last_name'
